import styled from '@emotion/styled';
import { colors } from 'Constants/Colors';
import { Card, palette } from '../../../Dashboard.styled';

export const HeroCard = styled(Card)<{ clickable?: boolean }>`
  margin-top: 12px;
  padding: 0;
  overflow: hidden;

  ${({ clickable }) =>
    clickable &&
    `
    cursor: pointer;
    transition: box-shadow 0.15s ease;

    &:hover,
    &:focus-visible {
      box-shadow: 0 4px 14px rgba(16, 24, 40, 0.12);
    }
  `}
`;

export const Thumb = styled.div<{ imageUrl?: string | null }>`
  height: 110px;
  background: ${({ imageUrl }) =>
    imageUrl
      ? `url("${imageUrl}") center / cover no-repeat`
      : `linear-gradient(135deg, ${palette.track}, ${colors.GREEN_ULTRA_LIGHT})`};
`;

export const HeroBody = styled.div`
  padding: 16px;
`;

export const Tag = styled.span`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: ${palette.green};
  color: ${colors.WHITE};
`;

export const HeroTitle = styled.p`
  margin: 8px 0 4px;
  font-size: 15px;
  font-weight: 700;
  color: ${palette.ink};
`;

export const HeroExcerpt = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${palette.muted};
`;

export const MiniCard = styled(Card)`
  margin-top: 12px;
  padding: 6px 16px;
`;
